import { useEffect, useRef, useState } from 'react';
import { searchSource } from '@/api/smartSearch';

export const DEBOUNCE_MS = 250;

const failed = (e) => ({ status: e?.code === 'ECONNABORTED' ? 'slow' : 'error', items: [], total: 0 });

// Live matches for the typed words, one group per source. Waits 250 ms after the last keystroke, cancels the previous
// requests on every change, and fills each group in as its source answers (a source over 2 s shows as slow).
export default function useSmartResults(text, sources, minChars) {
  const q = text.trim();
  const [res, setRes] = useState({ q: '', groups: {} });
  const keys = sources.map((s) => s.key).join(',');
  const live = useRef(sources);
  live.current = sources;

  useEffect(() => {
    setRes({ q, groups: {} });
    if (q.length < minChars || !keys) return undefined;
    const ctl = new AbortController();
    const put = (key, g) => { if (!ctl.signal.aborted) setRes((r) => ({ q, groups: { ...r.groups, [key]: g } })); };
    const t = setTimeout(() => {
      setRes({ q, groups: Object.fromEntries(live.current.map((s) => [s.key, { status: 'loading' }])) });
      live.current.forEach((s) => {
        searchSource(s.key, q, ctl.signal)
          .then((d) => put(s.key, { ...d, status: d.timed_out ? 'slow' : 'ready' }))
          .catch((e) => put(s.key, failed(e)));
      });
    }, DEBOUNCE_MS);
    return () => { clearTimeout(t); ctl.abort(); };
  }, [q, keys, minChars]);

  return res;
}
